import { FC, memo } from 'react';

import DispatchTableImportPresenter from './DispatchTableImportPresenter';

const DispatchTableImport: FC = memo(() => (
  <DispatchTableImportPresenter />
));

export default DispatchTableImport;
